module.exports = __webpack_public_path__ + "img/img04.b6b37a41.png";